import { render, staticRenderFns } from "./coordinators-list.vue?vue&type=template&id=651954ea&scoped=true"
import script from "./coordinators-list.vue?vue&type=script&lang=js"
export * from "./coordinators-list.vue?vue&type=script&lang=js"
import style0 from "./coordinators-list.vue?vue&type=style&index=0&id=651954ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651954ea",
  null
  
)

export default component.exports